export default defineNuxtRouteMiddleware(() => {
  // check if the user is logged in
  const { loggedIn } = useUserSession()
  console.log('Retskaffen :: Guard MW', loggedIn.value)
  // redirect the user to the login screen if they're not authenticated
  if (!loggedIn.value) {
    return navigateTo('/auth/discord', { external: true })
  }
})
